'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';

import Img from 'components/ui/Img';
import Link from 'components/ui/Link';
import Text from 'components/ui/Text';

import styles from './TalesFanStoryFooter.module.scss';

const image = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/4Tub0Fwi8Jx3hfC3LhGZDV/8c29a9ac6f786ebf60d671dc36c8bb14/tales-footer.png',
    width: 1092,
    height: 1295,
};

const TalesFanStoryFooter = ({ showLoadMore, buttonSlot }) => {
    return (
        <article
            className={cx(styles.root, {
                [styles.showLoadMore]: showLoadMore,
            })}
        >
            <div className={styles.lockup}>
                <Text
                    className={styles.headline}
                    baseTheme="displaySmall"
                    themes={{
                        large: 'displayLarge',
                    }}
                >
                    We want to hear from you!
                </Text>
                <Text
                    className={styles.copy}
                    baseTheme="bodyMedium"
                    themes={{
                        medium: 'bodyMedium',
                        large: 'bodyLarge',
                    }}
                >
                    Tell us your favorite Tillamook moments or what makes you a
                    loyal fan, and your story could be featured on our website.
                </Text>
                {buttonSlot}
                <div className={styles.termsContainer}>
                    <Text className={styles.termsText} baseTheme="bodySmall">
                        Not all submissions will be featured.{` `}
                        <Link
                            href={'/share-story/official-terms'}
                            target="_blank"
                        >
                            Terms Apply.
                        </Link>
                    </Text>
                </div>
            </div>
            <div className={styles.imageContainer}>
                {image?.url && (
                    <Img
                        className={styles.image}
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        fallbackImageWidth={768}
                        alt="Woman eating Tillamook ice cream"
                        customSources={[
                            {
                                breakpoint: 768,
                                src: image.url,
                                imageWidth: 1280,
                            },
                            {
                                src: image.url,
                                imageWidth: 768,
                            },
                        ]}
                    />
                )}
            </div>
        </article>
    );
};

export default TalesFanStoryFooter;
